import { render } from "./body_main_banner4.vue?vue&type=template&id=4e711601&scoped=true"
import script from "./body_main_banner4.vue?vue&type=script&lang=js"
export * from "./body_main_banner4.vue?vue&type=script&lang=js"

import "./body_main_banner4.vue?vue&type=style&index=0&id=4e711601&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e711601"]])

export default __exports__